import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Loadable from 'react-loadable';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { withAuthGuard } from 'ggApp/modules/router/hocs';

const Loading = (): JSX.Element => <CircleLoader />;

const Wrap = Loadable({
    loader: () => import(/* webpackChunkName: "YourPaymentsWrap" */ './wrap'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const PaymentsScreen = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "YourPaymentsScreen" */ 'ggApp/shared/screens/YourPayments/PaymentsScreen'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const GroupPaymentDetailView = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "GroupPaymentDetailsView" */ 'ggApp/shared/screens/YourPayments/GroupPaymentDetailsView'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const GuardScreen = ({ children }: { children: React.ReactElement }): JSX.Element => (
    <React.Fragment>{children}</React.Fragment>
);

const YourPaymentsRoutes = (): JSX.Element => (
    <Route path="your-payments" component={withAuthGuard(GuardScreen)}>
        <Route component={Wrap}>
            <IndexRoute component={PaymentsScreen} />
            <Route path=":groupPaymentId" component={GroupPaymentDetailView} />
        </Route>
    </Route>
);

export default YourPaymentsRoutes;
